import React from 'react'

export const useInternalState = state => {
  const [downloading, setDownloading] = React.useState(false)

  const { to, filename } = state

  const handleDownload = async () => {
    setDownloading(true)

    try {
      const response = await fetch(to)
      if (!response.ok) throw new Error('Download failed')

      const reader = response.body.getReader()
      const chunks = []

      while (true) {
        const { done, value } = await reader.read()
        if (done) break
        chunks.push(value)
      }

      const blob = new Blob(chunks)
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      link.click()
    } catch (err) {
      console.error(err)
      alert('Download failed')
    } finally {
      setDownloading(false)
    }
  }

  return {
    state: { downloading },
    handlers: { handleDownload },
  }
}
